import { render, staticRenderFns } from "./base_info_customer.vue?vue&type=template&id=13f4bf1f&scoped=true"
import script from "./base_info_customer.vue?vue&type=script&lang=js"
export * from "./base_info_customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f4bf1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f4bf1f')) {
      api.createRecord('13f4bf1f', component.options)
    } else {
      api.reload('13f4bf1f', component.options)
    }
    module.hot.accept("./base_info_customer.vue?vue&type=template&id=13f4bf1f&scoped=true", function () {
      api.rerender('13f4bf1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/components/base_info_customer.vue"
export default component.exports